/** CSV for the table export: RFC 4180 quoting, and a guard against a cell a spreadsheet would run.
 *
 * A cell that starts with `=`, `+`, `-`, `@`, a tab or a carriage return is read by Excel and Sheets as
 * a formula, so it is written with a leading single quote, which both programs show as text. A plain
 * number (`-12.5`) is left alone: a negative figure is not an injection, and prefixing it would turn a
 * number into text.
 *
 * CSV only. The codebase has no spreadsheet writer, and adding a library for one export would be a
 * decision of its own (rule 1).
 */

const NUMBER = /^-?\d[\d,]*(\.\d+)?$/;

export function csvCell(value: string): string {
  const guarded = /^[=+\-@\t\r]/.test(value) && !NUMBER.test(value) ? `'${value}` : value;
  return /[",\n\r]/.test(guarded) ? `"${guarded.replace(/"/g, '""')}"` : guarded;
}

export function toCsv(header: readonly string[], rows: readonly (readonly string[])[]): string {
  return [header, ...rows].map((row) => row.map(csvCell).join(",")).join("\r\n") + "\r\n";
}

/** Hand a CSV to the browser as a download. A byte-order mark is prefixed so Excel reads UTF-8. */
export function downloadCsv(filename: string, text: string): void {
  const blob = new Blob(["﻿", text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
